class DriverIdentificationMissingError extends Error {
  constructor(message="Identification for driver is missing") {
    super(message);
    this.name = 'DriverIdentificationMissingError';
  }
}

export default DriverIdentificationMissingError;
